import { FC } from "react";
import css from './index.module.css';

interface Popup {
  children: any,
  showPopup: boolean, 
  setShowPopup: any
}

const Popup: FC<Popup> = ({ children, showPopup, setShowPopup }) => {
  return (
    <div className={showPopup ? css.popup : `${css.popup} ${css.hidden}`}>
      <div className={css.popupBG} onClick={() => setShowPopup(false)} />
      <div className={css.popupBody}>
          <div className={css.popupContent}>
            <button className={css.closeBtn} aria-label="Закрыть" onClick={() => setShowPopup(false)}>
              <i className="fi fi-rr-cross"></i>
            </button>
            {children}
          </div>
      </div>
    </div>
  )
}

export default Popup;